import React from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { CreateGroupRequest } from '../../../../../types/spaceUserGroups';

interface Props {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (values: CreateGroupRequest) => Promise<boolean>;
  loading: boolean;
}

const CreateGroupModal: React.FC<Props> = ({ visible, onCancel, onSubmit, loading }) => {
  const [form] = Form.useForm();

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered
      maskClosable
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={async (values) => {
          const res = await onSubmit(values);
          res && form.resetFields();
        }}
      >
        <Form.Item
          name="name"
          label="Group Name"
          rules={[
            { required: true, message: 'Please enter a group name' },
            { 
              pattern: /^[a-zA-Z0-9-_ ]+$/, 
              message: 'Name can only contain letters, numbers, hyphens, underscores, and spaces' 
            }
          ]}
        >
          <Input placeholder="Enter group name" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Create Group
        </Button>
      </Form>
    </Modal>
  );
};

export default CreateGroupModal; 